import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info-page-content wiki-page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WikiBreadCrumbs = _resolveComponent("WikiBreadCrumbs")!
  const _component_WikiRoleGuide = _resolveComponent("WikiRoleGuide")!
  const _component_LocalizedTextWrapper = _resolveComponent("LocalizedTextWrapper")!
  const _component_SchemaImage = _resolveComponent("SchemaImage")!
  const _component_TopRolePlayer = _resolveComponent("TopRolePlayer")!
  const _component_WikiPlayCta = _resolveComponent("WikiPlayCta")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_WikiBreadCrumbs),
    _createElementVNode("h1", null, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "evil-loyalty-icon" }, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('roles.oberon')) + " " + _toDisplayString(_ctx.$t('roles.role')), 1)
    ]),
    _createVNode(_component_WikiRoleGuide, { role: "oberon" }),
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('oberon.generalInformation')), 1),
    _createElementVNode("p", null, [
      _createVNode(_component_LocalizedTextWrapper, { keypath: "oberon.playingAsOberon" })
    ]),
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('oberon.archetypes')), 1),
    _createElementVNode("div", null, [
      _createVNode(_component_LocalizedTextWrapper, { keypath: "oberon.archetypesDescription" })
    ]),
    _createElementVNode("ul", null, [
      _createVNode(_component_SchemaImage, {
        class: "archetype-image evil-role",
        role: "wraith",
        src: _ctx.calculateRoleUrl('wraith'),
        alt: _ctx.$t('roles.wraith'),
        description: _ctx.$t('roles.wraith')
      }, null, 8, ["src", "alt", "description"]),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('oberon.wraithArchetype')), 1),
        _createVNode(_component_LocalizedTextWrapper, { keypath: "oberon.wraithDescription" })
      ])
    ]),
    _createVNode(_component_TopRolePlayer, {
      role: "oberon",
      class: "my-4"
    }),
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('oberon.generalTips')), 1),
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('oberon.embraceMystery')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('oberon.useUnknownStatus')), 1)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('oberon.observeClosely')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('oberon.payAttention')), 1)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('oberon.actIndependently')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('oberon.withoutCoordination')), 1)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('oberon.misleadSubtly')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('oberon.makeStatements')), 1)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('oberon.takeRisks')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('oberon.needToMakeBoldMoves')), 1)
      ])
    ]),
    _createElementVNode("p", null, [
      _createVNode(_component_LocalizedTextWrapper, { keypath: "oberon.playingСonclusion" })
    ]),
    _createVNode(_component_WikiPlayCta)
  ]))
}